import React,{useEffect} from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import NoraAppBarMobile from './NoraAppBarMobile';
import NoraAppBarScreen from './NoraAppBarScreen';
import { HeaderTheme } from './HeaderTheme';
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import NoraMenuItems from './NoraMenuItems';
import useSharedDocHeader from './DocHeaderHook';


function NoraAppBar2() {
  const { t } = useTranslation(['categoryLabel','categoryMetaDesc']);
  const {titleKey,metaDescKey,routerId} = useSharedDocHeader();
  
  var metaDesc_val = t(metaDescKey);
  var title_val = t(titleKey);
  //console.log("cig",titleKey,title_val);
  
  useEffect(() => {
    document.title = 'Nora Vest, ' + title_val;
  }, [title_val]);

  useEffect(() => {
    const dommd = document.querySelector('meta[name="description"]');
    if (dommd)  dommd.setAttribute("content",metaDesc_val);
  }, []);
  

  useEffect(() => {
    const dommd = document.querySelector('meta[name="description"]');
    if (dommd)  dommd.setAttribute("content",metaDesc_val);
  }, [metaDesc_val]);

  return (
    <ThemeProvider theme={HeaderTheme}>
    <AppBar position="fixed"  elevation={0} sx={{
      backgroundColor: 'background.paper',
    }} 
  >
      <Container maxWidth="xl" sx={{my:0,
      by:0,
      py:0,}}>
        <Toolbar disableGutters={true}>
          <NoraAppBarMobile pages={NoraMenuItems} title={title_val}/>
          <NoraAppBarScreen pages={NoraMenuItems} title={title_val} selected={routerId}/>
        </Toolbar>  
      </Container>
    </AppBar>
    </ThemeProvider>
  );
}

export default NoraAppBar2;
